<template lang="html">
  <!-- TODO: place styles in parent -->
  <pl-dialog
    title="Poll - Vote"
    :size="'md'"
    :disableOutsideClick="true"
    @close="$emit('close')"
  >
    <div class="px-7 pt-4">
      <button
        v-if="!realTimeVote"
        class="py-2 hover:bg-gray-100"
        @click="closePollDialog()"
      >
        <i class="fas fa-arrow-left" />
        <span>Back to Polls</span>
      </button>
    </div>
    <body class="px-7 py-4 flex-grow overflow-y-auto">
      <p class="text-lg font-semibold mb-4">{{ selectedPoll.question }}</p>
      <div
        v-for="(answer, index) in selectedPoll.answers"
        :key="`voting-${answer}-${index}`"
        @click="
          selected_answer_index === index
            ? (selected_answer_index = -1)
            : (selected_answer_index = index)
        "
        class="ellipsis-text w-full border rounded h-12 px-3 mb-2 flex items-center cursor-pointer hover:bg-gray-100"
        :class="{
          'bg-primary-light hover:bg-primary-light':
            index === selected_answer_index,
        }"
      >
        <p>{{ answer }}</p>
      </div>
    </body>
    <footer class="flex center items-center pt-5 pb-5 px-7">
      <button
        :disabled="selected_answer_index === -1 || processing"
        @click="submitVote"
        class="text-white bg-primary rounded font-semibold px-8 py-2 disabled:opacity-50"
      >
        <span v-if="processing">Processing...</span>
        <span v-else>Submit</span>
      </button>
    </footer>
  </pl-dialog>
</template>
<script>
  import { mapGetters } from 'vuex';
  import { EventBus } from '../../utils/event-bus';

  export default {
    data() {
      return {
        selected_answer_index: -1,
        processing: false,
      };
    },
    components: {},
    computed: {
      ...mapGetters(['getCurrentDiscussion']),
    },
    props: {
      selectedPoll: {
        type: Object,
        default: () => ({
          id: '',
          question: '',
          answers: [],
        }),
      },
      realTimeVote: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      submitVote() {
        const vote = [this.selectedPoll.answers[this.selected_answer_index]];
        this.processing = true;
        this.$store.dispatch('voteOnPoll', {
          poll_id: this.selectedPoll.id,
          vote,
        });
      },
      closePollDialog() {
        this.$emit('closePollDialog');
      },
    },
    mounted() {
      EventBus.$on('close_dialog_poll', () => {
        this.closePollDialog();
      });
      EventBus.$on('clear_vote', () => {
        this.selected_answer_index = -1;
        this.closePollDialog();
      });
    },
  };
</script>



// WEBPACK FOOTER //
// polls.vote.vue?7950b4c4